<template>
  <div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" size="mini" label-width="110px" :model="formData" ref="searchForm" class="search-form">
            <el-form-item label="商品编码" prop="goodsCode">
              <el-input v-model.trim="formData.goodsCode" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="商品名称" prop="goodsName">
              <el-input v-model.trim="formData.goodsName" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="清仓销售价系数" prop="clearancePrice">
              <el-select v-model="formData.clearancePrice" multiple collapse-tags placeholder="请选择" clearable @change="onSearch">
                <el-option :label="item.optionValue" :value="item.optionValue" v-for="item in optsList[0]" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否清仓" prop="clearance">
              <el-select v-model="formData.clearance" placeholder="全部" clearable @change="onSearch">
                <el-option label="全部" value="" />
                <el-option label="是" value="是" />
                <el-option label="否" value="否" />
                <el-option label="-" value="-" />
              </el-select>
            </el-form-item>
            <el-form-item label="更新人" prop="updatedBy">
              <el-input v-model.trim="formData.updatedBy" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="更新时间">
              <form-date-range :form="formData" startKey="startTime" endKey="endTime" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
          </template>
        </search-box>
      </template>

      <table-panel ref="tablePanel">
        <template v-slot:header-right>
          <el-button type="primary" size="mini" @click="importExcel">导入</el-button>
          <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
        </template>
        <el-table
          border
          stripe
          ref="tableRef"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
          v-loading="loading"
          v-if="tableReload"
        >
          <el-table-column :show-overflow-tooltip="true" label="商品编码" prop="goodsCode"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="商品名称" prop="goodsName"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="清仓销售价系数" prop="clearancePrice"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="更新人员" prop="updatedBy"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="更新时间" prop="updatedDate"></el-table-column>
          <el-table-column label="操作" align="center" width="90">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="edit(scope.row)">编辑</el-link>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageIndex"
              :page-sizes="page.sizes"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              background
              :total="page.total"
            ></el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <!-- dialog -->
    <edit
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :rowData="rowData"
      @success="init"
    />
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import edit from './price-uphold-edit';

export default {
  components: { edit },
  name: 'SalesPriceUphold',
  mixins: [pagePathMixin, tableMixin],
  data() {
    return {
      formData: {
        goodsCode: '',
        goodsName: '',
        clearancePrice: [],
        clearance: '',
        updatedBy: '',
        startTime: '',
        endTime: ''
      },
      tableReload: true,
      tableData: [],
      page: {
        pageIndex: 1,
        sizes: [30, 100, 500, 1000],
        pageSize: 30,
        total: 0
      },
      dialogVisible: false,
      rowData: {},
      loading: false,
      // 搜索相关
      optsList: []
    };
  },
  mounted() {
    this.get_options();
    this.init();
  },
  methods: {
    // 搜索相关方法
    onSearch() {
      this.page.pageSize = 30;
      this.page.pageIndex = 1;
      this.init();
    },
    reset() {
      this.formData = {
        goodsCode: '',
        goodsName: '',
        clearancePrice: [],
        clearance: '',
        updatedBy: '',
        startTime: '',
        endTime: ''
      };
      this.page.pageIndex = 1;
      this.init();
    },
    get_options() {
      let types = ['32'];
      this.request(types, 0);
    },
    request(types, index) {
      let data = {
        filterData: {
          optionType: types[index],
          tag: 2
        },
        pageNum: 1,
        pageSize: 1000
      };
      if (!types[index]) {
        return false;
      }
      this.$q.goods.listPage({ data }).then((res) => {
        this.optsList.push(res.data.records);
        index++;
        this.request(types, index);
      });
    },
    // 分页器
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageIndex = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.init();
    },
    // 数据初始化
    init() {
      this.loading = true;
      let data = {
        exportTag: true,
        filterData: { ...this.formData },
        pageNum: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      this.$q.goods
        .goodsPriceCoefficientList({ data: data })
        .then((res) => {
          if (res.code == 200 && res.data.records) {
            this.tableData = res.data.records;
            this.page.total = res.data.total;
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    edit(row) {
      this.rowData = row;
      this.dialogVisible = true;
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let filterData = { ...this.formData };
      filterData.pageNum = 1;
      filterData.pageSize = 2147483647;
      filterData.exportTag = true;

      let params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...filterData
        },
        reportName: 'goodsPriceCoefficientExport'
      };
      this.$q.orderDate
        .importExcel({ data: params })
        .then((res) => {
          if (res.success) {
            this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally((_) => {
          loading.close();
        });
    },
    importExcel() {
      this.openSubPage({
        path: '/dataImport/goodsPriceCoefficientImport',
        query: {
          fileName: '商品价格系数维护_模板.xlsx',
          appCode: 'ec-pc-api'
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important
</style>
